<template>
    <header class="mb-6">
        <app-heading
            element="h2"
            v-html="title"
        />

        <span v-if="subTitle" v-html="subTitle" class="block mt-1 text-sm text-grey-darker"></span>
    </header>
</template>

<script>
    /* Components */
    import Heading from '@/components/Heading';
    export default {
        name: 'app-title',
        components: {
            'app-heading': Heading
        },
        props: {
            title: {
                type: String,
                required: true
            },
            subTitle: {
                type: String,
                required: false
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Title.vue